import { DebitForm, PaymentAddProps } from '@fox/finance';
import { nanoid } from 'nanoid';
import { useContentContext } from '../../../content-context';
import { useCreateDebit } from '../../mutation-hooks/mutation-implementations';

export const CreateDebit = ({ onSuccess, provider, onCancel, meta }: PaymentAddProps) => {
	const { requestToken, contentId } = useContentContext();
	const useLinkedOrganisationData = meta?.['useLinkedOrganisationData'] === true;
	const { error, mutate } = useCreateDebit({ requestToken });

	return (
		<DebitForm
			onCancel={onCancel}
			submitFunc={async ({ accountName, accountNumber, bsb }) => {
				const result = await mutate({
					contentId,
					useLinkedOrganisationData,
					accountName,
					sourceId: nanoid(),
					account: accountNumber,
					bsb,
					provider: provider.provider
				});
				if (result?.id) {
					onSuccess(result.id);
				}
			}}
			apiErrors={error ? [error] : undefined}
		/>
	);
};
